<template>
            <div class="card">
                    <div class="col" >
                            <h2 class="bg-secondary text-center" v-if="currentVideoid" v-html="'<strong>Video:</strong> ' + currentVideoname"></h2>
                            <button class="btn btn-sm btn-success" v-if="currentVideoid" @click="resetForNew()">New Video</button>
                            <div class="row mx-auto my-2 d-flex justify-content-center" >
                                <label class="text-dark" for="name">Video Name: </label>
                                <input style="max-width:50%;margin:auto;" type="text" v-model="currentVideoname" class="form-control"/>
                            </div>
                            <div class="row mx-auto my-2 d-flex justify-content-center" >
                                <label class="text-dark" for="description">Video Description<br/></label>
                                <input style="max-width:50%;margin:auto;" type="text" v-model="currentVideodescription" class="form-control"    />
                            </div>
                            <div class="row mx-auto my-2 d-flex justify-content-center" >
                                <label class="text-dark" for="videourl">Video URL: </label>
                                <input style="max-width:50%;margin:auto;" type="text" v-model="currentVideovideourl" class="form-control"  />
                            </div>
                            <div class="row mx-auto my-2 d-flex justify-content-center" v-if="videoList" >
                                <label class="text-dark" for="videos">Your Videos:</label>
                                <select  class="form-control" style="max-width:50%;margin:auto;" @change="loadVideo()"  v-model="currentVideoid" >
                                    <option name="" value="">Select</option>
                                     <option
                                            v-for="video in videoList"
                                            :key="video.id"
                                            :value="video.id"
                                        >{{ video.name }}</option>
                                </select>
                            </div>
<!-- Note, don't put the tinymce editor in a div or p tag, as it becomes uneditable on observations load.
    Haven't figured out how this could be...-->

                                <label class="text-dark" >Observations:</label>
                                <vObservations ref="videoInp"
                                    :api-key="apikey"
                                    cloud-channel="6"
                                    :disabled=false
                                    id="videoid"
                                    :init= "getInitMenuPlugins()"
                                    :inline=false
                                    model-events= ""
                                    plugins=""
                                    tag-name="div"
                                    toolbar=""
                                    value=""
                                    name="xxx"
                                    v-model="currentVideoobservations"
                                />
                            <div class="card embed-responsive embed-responsive-16by9" v-if="currentVideovideourl != ''">
                                <iframe id="video1" :src="convertToEmbedUrl(currentVideovideourl)"
                                    frameborder="0" allow="autoplay; fullscreen" allowfullscreen>
                                </iframe>
                            </div>
                        </div>

                        <div class="row mx-auto d-flex justify-content-center" >
                            <button class="btn btn-lg btn-warning float-right mx-2 my-2" :disabled="currentVideoid == ''" @click="doubleConfirmDeleteAction()">Delete Selected</button>
                            <button class="btn btn-lg btn-primary float-right  mx-2 my-2" :disabled="!currentVideoSaveable()" @click="saveVideoAction">Save  Video</button>
                         </div>


            </div>

</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import EventBus from '../../event-bus';
import Editor from '@tinymce/tinymce-vue';
// import { v4 as uuidv4 } from 'uuid';

export default {
    components: {
        vObservations: Editor,
        // videoObservations2: Editor,
     },
    name: "UserVideoSetup",
    data() {
        return {
            csrf_token: document.head.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            userinfo:'',
            currentVideo: '',
            videourl:'',
            videoList:'',
            currentVideoid: '',
            currentVideoname:'',
            currentVideodescription: '',
            currentVideovideourl: '',
            currentVideoobservations: '',
            currentVideoobservationsxx: 'xyz xyz'
        }
    },

    props: {
        userdata:'',
        videos:'',
        apikey:'',
    },
    mounted() {
            this.userinfo = JSON.parse(this.userdata);
            this.videoList = JSON.parse(this.videos);

        //Helps overcome Bootstrap blocking of the Image input:
        // $(document).on('focusin', function(e) {
        //     if ($(e.target).closest(".tox-tinymce, .tox-tinymce-aux, .moxman-window, .tam-assetmanager-root").length) {
        //         e.stopImmediatePropagation();
        //     }
        //     });
    },


    methods: {
        resetForNew() {
             console.error("resetForNew: ");
                this.currentVideoname = '';
                this.currentVideodescription =  '';
                this.currentVideovideourl = '';
                this.currentVideoobservations =  '';
                this.currentVideoid = '';
        },
        loadVideo() {
            if(this.currentVideoid != '')  {
                console.error("Loading video: " + this.currentVideoid);
                var selVideo = this.getVideo(this.currentVideoid);
                this.currentVideoname = selVideo.name;
                this.currentVideodescription = selVideo.description;
                this.currentVideovideourl = selVideo.videourl;
                this.currentVideoobservations = selVideo.observations;
            } else {
                this.resetForNew();
            }
        },
        // convertToEmbedUrl(youtubeUrl) {
        //     // Extract the video ID using a regular expression
        //     const match = youtubeUrl.match(/(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
        //     if (match && match[1]) {
        //         // Build the embed URL with the extracted video ID
        //         const embedUrl = `https://www.youtube.com/embed/${match[1]}`;
        //         return embedUrl;
        //     } else {
        //         // Handle invalid or unsupported URL formats
        //         console.error('Invalid YouTube URL:', youtubeUrl);
        //         this.updateToast('Invalid YouTube URL:'+ youtubeUrl, 4000, 'error');
        //         return null;
        //     }
        // },
// convertToEmbedUrl(youtubeUrl) {
//   // Regular expression to match YouTube URLs with and without cookies
//   const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube(?:-nocookie)?\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;

//   // Extract the video ID using the regular expression
//   const match = youtubeUrl.match(regex);

//   if (match && match[1]) {
//     // Build the embed URL with the extracted video ID
//     const embedUrl = `https://www.youtube.com/embed/${match[1]}`;
//     return embedUrl;
//   } else {
//     // Handle invalid or unsupported URL formats
//     console.error('Invalid YouTube URL:', youtubeUrl);
//     return null;
//   }
// },
convertToEmbedUrl(videoUrl) {
  // Regular expressions to match YouTube and Vimeo URLs
    const youtubeRegex = /(?:https?:\/\/)?(?:www\.)?(?:youtube(?:-nocookie)?\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const vimeoRegex = /(?:https?:\/\/)?(?:www\.)?(?:player\.)?vimeo\.com\/(?:video\/)?(\d+)/;

    // Check if the URL is a YouTube URL
    const youtubeMatch = videoUrl.match(youtubeRegex);
   const vimeoMatch = videoUrl.match(vimeoRegex);
    if ((youtubeMatch && youtubeMatch[1]) || (vimeoMatch && vimeoMatch[1])) {
        if (youtubeMatch && youtubeMatch[1]) {
            // Build the YouTube embed URL with the extracted video ID
            return `https://www.youtube.com/embed/${youtubeMatch[1]}`;
        }
        // or Check if the URL is a Vimeo URL
            if (vimeoMatch && vimeoMatch[1]) {
            // Return the Vimeo URL unchanged
            return videoUrl;
        }
    } else {
        this.updateToast('Please paste a valid url. App cannot handle URL provided', 4000, 'error');
        return null;
    }

    // If the URL is not recognized as YouTube or Vimeo, return it unchanged
    return videoUrl;
},
        getVideo(videoid) {
            var theVideo= '';
            [...this.videoList].forEach(aVideo=>{
                if(aVideo.id == videoid) theVideo = aVideo;
            });
            return theVideo;
        },
        currentVideoSaveable() {
            return this.currentVideoname != '' && this.currentVideodescription != '' && this.currentVideovideourl != '';
        },
        saveVideoAction() {
                axios.post('/user/videos/saveupdate', {
                    owner_id:this.userinfo.id,
                    id:this.currentVideoid,
                    name:this.currentVideoname,
                    description: this.currentVideodescription,
                    videourl: this.currentVideovideourl,
                    observations: this.currentVideoobservations,
                })
                .then(res => {
                    this.loading = false;
                    this.success = true;
                    this.message = res.data.message;
                    this.updateToast(this.message, 4000);
                    console.error(res.data.message);
                    this.videodata = JSON.parse(res.data.videos);
                //    this.$forceUpdate();
location.reload();
                })
                .catch(err => {
                    console.error(err);
                    this.updateToast(err.message, 4000, 'error');
                })
                .finally(()=> {
                    // this.$forceUpdate();

                });
            },
        doubleConfirmDeleteAction() {
            Swal.fire({
                title: 'Please confirm deletion of the currently selected video: ' + this.currentVideoname ,
                showDenyButton: true,
                // showCancelButton: true,
                confirmButtonText: 'Delete',
                denyButtonText: `Don't delete`,
            }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    this.deleteVideoAction();
                    // Swal.fire('Deleted!', '', 'success');
                } else if (result.isDenied) {
                    Swal.fire('Asset was not deleted', '', 'info');
                }
            });
        },
        deleteVideoAction() {
            axios.post('/user/videos/'+this.currentVideoid+'/delete', {
                owner_id:this.userinfo.id,
                id:this.currentVideoid,
            })
            .then(res => {
                this.loading = false;
                this.success = true;
                this.message = res.data.message;
                this.updateToast(this.message, 4000);
                console.error(res.data.message);
                this.videoList = JSON.parse(res.data.videos);
                location.reload();
            })
            .catch(err => {
                console.error(err);
                this.updateToast(err.message, 4000, 'error');
            })
            .finally(()=> {
                this.$forceUpdate();
            });
        },
        modalReset() {
            //set all fields to blank
            this.videodata.id = '';
            this.videodata.name = '';
            this.videodata.description = '';
            this.videodata.videourl = '';
        },
        getInitMenuPlugins() {
            return {
                height: 200,
                menubar: false,
                link_context_toolbar: true,
                image_class_list: [
                    {title: 'Responsive', value: 'img-responsive'}
                ],
                plugins: 'code table lists image',
                toolbar: 'undo redo | formatselect| bold italic | alignleft aligncenter alignright | indent outdent | bullist numlist | link | image code | table'
            }
        },
        // getInitMenuPlugins() {
        //     return {
        //         height: 200,
        //         menubar: false,
        //         plugins: [
        //             'code table lists'
        //         ],
        //         toolbar:
        //             'undo redo | formatselect | bold italic backcolor | \
        //             alignleft aligncenter alignright alignjustify | \
        //             bullist numlist outdent indent | removeformat | help'
        //     }
        // },
        preventBootstrap() {
            // Prevent Bootstrap dialog from blocking focusin
            $(document).on('focusin', function(e) {
            if ($(e.target).closest(".tox-tinymce, .tox-tinymce-aux, .moxman-window, .tam-assetmanager-root").length) {
                e.stopImmediatePropagation();
            }
            });
        },

        saveAction() {
            this.saveDetails();
        },
        updateToast(message, timer = 2000, icon='success') {
            const Toast = Swal.mixin({
                position: 'center',
                width: 500,
                showConfirmButton: true,
            });
            Toast.fire({
                icon: icon,
                title: message
            });
        },
        cancel() {
            // EventBus.$emit('refreshLessonParent');
            $('div#edit-lesson-modal').modal('hide');
        },
    },
    computed: {
    },
}
</script>
<style>
.bg-custom{
    background: #449acb;
color: #fff;
}

.video-container {
  position: relative;
  width: 50%; /* Adjust as needed */
  height: auto; /* Adjust as needed */
  max-width: 800px; /* Optional: Set a maximum width */
  margin: 0 auto; /* Optional: Center the video */
}
</style>
